var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.fournisseurRtc)?_c('div',[_vm._v(" Fournisseur RTC: "+_vm._s(_vm.fournisseurRtc.valeur)+" "),_c('v-btn',{on:{"click":_vm.onChangeModeRtc}},[_vm._v(" Change ")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }